module.exports = __webpack_public_path__ + "img/locator-sentosa.9a6d6e8a.svg";